import { authHeaders } from "./auth";
import { Department, Role } from "../types";

export const API_BASE =
  import.meta.env.VITE_API_BASE || "http://localhost:4000/api";

export async function fetchJSON(path: string, options: RequestInit = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...authHeaders(),
      ...options.headers,
    },
    ...options,
  });

  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function assignUserToEmployee(
  employeeId: string,
  userId: number | null,
) {
  return fetchJSON(`/api/employees/${employeeId}/assign-user`, {
    method: "PUT",
    body: JSON.stringify({ user_id: userId }),
  });
}

export async function getAvailableUsers() {
  return fetchJSON("/api/users/available");
}

export async function getRoles(): Promise<Role[]> {
  return fetchJSON("/api/roles");
}

export async function createRole(data: {
  name: string;
  label: string;
  description?: string;
}): Promise<Role> {
  return fetchJSON("/api/roles", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateRole(
  id: number,
  data: { name: string; label: string; description?: string },
): Promise<Role> {
  return fetchJSON(`/api/roles/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteRole(id: number): Promise<{ success: boolean }> {
  return fetchJSON(`/api/roles/${id}`, { method: "DELETE" });
}

export async function getDepartments(): Promise<Department[]> {
  return fetchJSON("/api/departments");
}

export async function createDepartment(data: {
  name: string;
  label: string;
  description?: string;
}): Promise<Department> {
  return fetchJSON("/api/departments", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateDepartment(
  id: number,
  data: { name: string; label: string; description?: string },
): Promise<Department> {
  return fetchJSON(`/api/departments/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteDepartment(
  id: number,
): Promise<{ success: boolean }> {
  return fetchJSON(`/api/departments/${id}`, { method: "DELETE" });
}
